import React from "react";
import { motion, useInView } from "framer-motion";
import { useRef } from "react";

const Projects = () => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: false });

  const ref1 = useRef(null);
  const pInView = useInView(ref1, {once: false});

  const aboutText =
    "Full-stack developer with a frontend focus and passionate about crafting performant, scalable, and maintainable web applications. Skilled in React, TypeScript, Redux, Gatsby, and Vite on the frontend, with experience in building and integrating robust backends using Node.js, Flask, and Spring Boot. Comfortable across the stack, from Dockerized CI/CD workflows to automated testing with Cypress and Jest, and always driven by clean code and intuitive user experience.";

  return (
    <div>
      <motion.div
        ref={ref}
        initial={{ opacity: 0, y: 50 }}
        animate={isInView ? { opacity: 1, y: 0 } : {}} // only animate when in view
        transition={{ duration: 0.01, ease: "easeOut" }}
        className="stats bg-transparent w-full pt-5 flex flex-col overflow-hidden"
      >
        <div className="stat shadow flex items-center justify-center">
          <div className="stat-value lg:text-5xl text-md">About me</div>
        </div>
        <motion.div
          ref={ref1}
          initial={{ opacity: 0, y: 50 }}
          animate={isInView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.8, ease: "easeOut" }}
          style={{
            maxWidth: "800px",
            margin: "20px auto",
            padding: "2rem",
            textAlign: "center",
            borderRadius: "12px",
            border: "none"
          }}
        >
          <p>
            {aboutText}
          </p>
        </motion.div>
      </motion.div>
    </div>
  );
};

export default Projects;
